function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import * as React from 'react';
import tabbable from 'tabbable';
import { default as CloseIcon } from '../../Icons/CloseX/CloseX';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import uuid from '../../utils/uuid';
import AdditionalIntl from '../../I18n/AdditionalIntl/AdditionalIntl';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import I18n from '../../I18n/I18n/I18n';
import IconButton from '../../Buttons/IconButton/IconButton';
import ThemeContext from '../../ThemeContext';
import en from './locales/Filters.en.json';
import './Filters.css';
var MESSAGE_PREFIX = '@dm/components.filters';
var message = function message(id) {
  return "".concat(MESSAGE_PREFIX, ".").concat(id);
};
var messages = normalizeLocaleData(en, MESSAGE_PREFIX);
var FilterValue = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterValue, _React$Component);
  function FilterValue() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, FilterValue);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FilterValue)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.handleClick = function (e) {
      var _this$props = _this.props,
        accessor = _this$props.accessor,
        index = _this$props.index,
        label = _this$props.label,
        value = _this$props.value,
        onRemove = _this$props.onRemove;
      onRemove({
        accessor: accessor,
        index: index,
        label: label,
        value: value
      }, e.currentTarget);
    };
    return _this;
  }
  _createClass(FilterValue, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        label = _this$props2.label,
        value = _this$props2.value;
      return /*#__PURE__*/React.createElement("span", {
        className: "_dm-filter__value"
      }, value, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
        value: "dm"
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: this.handleClick,
        className: "_dm-filter__remove"
      }, /*#__PURE__*/React.createElement(ButtonLabel, {
        i18n: {
          id: message('label-remove'),
          values: {
            label: label,
            value: value
          }
        },
        hideLabel: true
      }), /*#__PURE__*/React.createElement(CloseIcon, {
        className: "_dm-filter__close-icon",
        width: 10,
        height: 10
      }))));
    }
  }]);
  return FilterValue;
}(React.Component);
var FilterGroup = function FilterGroup(props) {
  var accessor = props.accessor,
    describedby = props.describedby,
    label = props.label,
    values = props.values,
    onRemove = props.onRemove;
  return /*#__PURE__*/React.createElement("span", {
    className: "_dm-filter__group"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-describedby": describedby
  }, label, ": "), values.map(function (value, index) {
    return /*#__PURE__*/React.createElement(FilterValue, {
      accessor: accessor,
      key: "".concat(value, "-").concat(index),
      index: index,
      label: label,
      onRemove: onRemove,
      value: value
    });
  }));
};
export default function Filters(props) {
  var containerRef = React.useRef(null);
  var timeoutRef = React.useRef(null);
  var i18nKey = message(props.filters.length === 0 ? 'label-no-filters' : 'label-filters');
  var labelId = uuid();
  function handleRemove(_ref, el) {
    var accessor = _ref.accessor,
      index = _ref.index,
      label = _ref.label,
      value = _ref.value;
    var ref = containerRef.current;
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (ref) {
      var tabbables = tabbable(ref);
      var currentIndex = tabbables.findIndex(function (node) {
        return node === el;
      });
      var firstHalf = tabbables.slice(0, currentIndex);
      var secondHalf = tabbables.slice(currentIndex + 1);
      var toFocus = firstHalf.length ? firstHalf[firstHalf.length - 1] : secondHalf.length ? secondHalf[0] : ref;
      timeoutRef.current = setTimeout(function () {
        toFocus && toFocus.focus();
      }, 100);
    }
    props.onRemove && props.onRemove({
      accessor: accessor,
      index: index,
      label: label,
      value: value
    });
  }
  return /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: messages
  }, /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: "_dm-filter__container",
    tabIndex: -1,
    "aria-live": "polite"
  }, /*#__PURE__*/React.createElement("div", {
    className: "_dm-filter__label"
  }, /*#__PURE__*/React.createElement("strong", {
    id: labelId
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: i18nKey
  }))), /*#__PURE__*/React.createElement("div", {
    className: "_dm-filter__groups"
  }, props.filters.map(function (entry) {
    return /*#__PURE__*/React.createElement(FilterGroup, {
      describedby: labelId,
      accessor: entry.accessor,
      key: entry.accessor,
      label: entry.label,
      onRemove: handleRemove,
      values: entry.values
    });
  }))));
}